import { combineReducers } from '@reduxjs/toolkit';

import licenseChildrenSlice from '../modules/LicenseChildren/store/slices';
import { licenses } from '../modules/Licenses/store/slices';
import licenseSlice from '../modules/License/store/slice';

import rimmSlice from '../modules/rimm/store/slices';
import licenseTypeSlice from './licenseType/slice';
import { configs } from './configs/slices';
import { audit } from './audit/slices';

export default combineReducers({
  [configs.name]: configs.reducer,
  [licenses.name]: licenses.reducer,
  [licenseSlice.name]: licenseSlice.reducer,
  [licenseTypeSlice.name]: licenseTypeSlice.reducer,
  [licenseChildrenSlice.name]: licenseChildrenSlice.reducer,
  [audit.name]: audit.reducer,
  [rimmSlice.name]: rimmSlice.reducer,
});
